import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { fetchRefundSubmissions } from "../repo/ticketRefundRepo";

/** 查询键隔离团、申请与分页；关闭抽屉后不保留个人资料缓存。 */
export function useRefundSubmissionHistory(teamId: string, requestId: string) {
  const [page, setPage] = useState(1);
  const query = useQuery({ queryKey: ["ticket-refund-submissions", teamId, requestId, page],
    queryFn: () => fetchRefundSubmissions(teamId, requestId, page), gcTime: 0, retry: false });
  return { query, page, setPage };
}
